import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import Loader from "../components/Loader";

const API_BASE = `${BASE_URL}api/export`; // Use BASE_URL for API base

const MasterSuppressions = () => {
  const [columns, setColumns] = useState([]);
  const [selected, setSelected] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch column names on mount
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE}/export-column-names`)
      .then((res) => setColumns(res.data))
      .catch((err) => {
        setColumns([]);
        // Show error from backend if available
        let msg = "Failed to fetch columns.";
        if (err.response?.data?.error) {
          msg += " " + err.response.data.error;
        }
        if (err.response?.data?.sqlsrv_errors) {
          msg += " " + JSON.stringify(err.response.data.sqlsrv_errors);
        }
        alert(msg);
        // Also log full error for debugging
        console.error("Column fetch error:", err, err?.response?.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleCheck = (col) => {
    setSelected((prev) =>
      prev.includes(col)
        ? prev.filter((c) => c !== col)
        : [...prev, col]
    );
  };

  const handleDownload = async () => {
    if (selected.length === 0) return;
    setDownloading(true);
    try {
      // Download as a blob (stream)
      const params = new URLSearchParams();
      selected.forEach((col) => params.append("column", col));
      const response = await axios.get(
        `${API_BASE}/export-columns?${params.toString()}`,
        { responseType: "blob" }
      );
      // Get current date for filename
      const now = new Date();
      const month = now.toLocaleString("en-US", { month: "short" });
      const day = now.getDate();
      const year = now.getFullYear();
      const dateStr = `${month}${day}_${year}`; // e.g. May26_2025
      const filename = `All_Master_Suppressions_${dateStr}.csv`;
      // Download file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Failed to download CSV.");
    }
    setDownloading(false);
  };

  return (
    <>
      {(loading || downloading) && <Loader message={loading ? "Loading columns..." : "Downloading CSV..."} />}
      <div className="container py-4" style={{ opacity: loading || downloading ? 0.5 : 1, pointerEvents: loading || downloading ? "none" : "auto" }}>
        <h2>Master Suppressions</h2>
        <div className="mb-3">
          <strong>Select columns to export:</strong>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem",
              marginTop: "1rem",
            }}
          >
            {columns.map((col) => (
              <label key={col} style={{ minWidth: 180 }}>
                <input
                  type="checkbox"
                  checked={selected.includes(col)}
                  onChange={() => handleCheck(col)}
                />{" "}
                {col}
              </label>
            ))}
          </div>
        </div>
        <button
          className="btn btn-primary"
          disabled={selected.length === 0 || downloading}
          onClick={handleDownload}
        >
          {downloading ? "Downloading..." : "Download CSV"}
        </button>
      </div>
    </>
  );
};

export default MasterSuppressions;